import DeliveryProviderService from './services';
import DeliveryProviderTypes from './types';

export const listDeliveryProvider = (newProduct?: boolean) =>
  DeliveryProviderTypes.list.createAction(() => DeliveryProviderService.listDeliveryProvider(newProduct));
export const uploadDeliveryProviderFile = (files: any[], product: any, methodId: any) =>
  DeliveryProviderTypes.uploadFile.createAction(() => DeliveryProviderService.uploadDeliveryProviderFile(files, product, methodId));
export const uploadDeliveryProvider = (deliveries: any, product: any) =>
  DeliveryProviderTypes.upload.createAction(() => DeliveryProviderService.uploadDeliveryProvider(deliveries, product));
export const createBatch = (id: any, pins: any) =>
  DeliveryProviderTypes.createBatch.createAction(() => DeliveryProviderService.createBatch(id, pins));
